export const ACCEPTED_IMAGE_TYPES = [
  'image/jpeg',
  'image/jpg',
  'image/png',
  'image/webp',
];

const ACCEPTED_VIDEO_TYPES = ['video/mp4', 'video/x-m4v', 'application/mp4'];

export const ACCEPTED_MEDIA_TYPES = [
  ...ACCEPTED_IMAGE_TYPES,
  ...ACCEPTED_VIDEO_TYPES,
];

export const MAX_IMAGE_SIZE = 3 * 1024 * 1024;
export const MAX_VIDEO_SIZE = 30 * 1024 * 1024;
